import React, { FC } from 'react';

import AnimatedNumber from 'react-animated-number';
import { Grid, Hidden } from '@material-ui/core';

import { IRoundPayment } from '../../../../store/admin/roundPayments/store';
import { formatTotal } from '../../../common/Utils/formatTotal';

interface IProps {
  payment: IRoundPayment;
}

export const TotalPlayersAndCharges: FC<IProps> = props => {
  const { payment } = props;

  return (
    <Grid className="charges" container={true} spacing={2}>
      <Hidden smDown={true}>
        <Grid item={true} xs={2} />
      </Hidden>
      <Grid item={true} xs={6} sm={3} md={2}>
        <div className="label">Total registered players</div>
      </Grid>
      <Grid item={true} xs={6} sm={3} md={2}>
        <div className="value">
          <span>{payment.items.registeredPlayers}</span>
        </div>
      </Grid>

      <Grid item={true} xs={6} sm={3} md={2}>
        <div className="label">Total charges</div>
      </Grid>
      <Grid item={true} xs={6} sm={3} md={2}>
        <div className="value">
          <span>
            <AnimatedNumber
              component="div"
              stepPrecision={2}
              value={payment.totalPrice || 0}
              duration={750}
              formatValue={formatTotal}
            />
          </span>
        </div>
      </Grid>
      <Hidden smDown={true}>
        <Grid item={true} xs={2} />
      </Hidden>
    </Grid>
  );
};
